import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/appointment-forms')({
  component: AppointmentFormsLayout,
});

function AppointmentFormsLayout() {
  return <Outlet />;
}
